import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/Card/CardAnatomy.mdx";
import Usage from "../../Docs/Components/Card/CardUsage.mdx";

import Examples from "../../Docs/Components/Card/CardExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Card"
            description="A card is a visual container that organizes and groups information and/or actions related to a single concept."
            apiSources={["azure-devops-ui/Components/Card/Card.Props.d.ts"]}
            examples={Examples}
            internalLinks={{"figma":"https://www.figma.com/file/Rzm5wnIaeRtbN7BTR5AiKYCQ/Cards"}}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;